export const sha256 = async (input: string): Promise<string> => {
  const data = new TextEncoder().encode(input);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
};

// Returns SHA-256 hashes for the identity fields shipped with tracking
// events. Email is normalized (trim + lowercase) before hashing to match
// the convention used by ad platforms (Meta CAPI, Google enhanced
// conversions). Phone must already be in E.164 form when passed in.
export const hashIdentity = async ({
  email,
  phone,
}: {
  email?: string | null;
  phone?: string | null;
}): Promise<{ email?: string; phone?: string }> => {
  const result: { email?: string; phone?: string } = {};
  if (email) result.email = await sha256(email.trim().toLowerCase());
  if (phone) result.phone = await sha256(phone);
  return result;
};
